import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0720e5c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home__team",
  id: "team"
}
const _hoisted_2 = { class: "team__header-wrapper" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "team__content-wrapper" }
const _hoisted_6 = { class: "team__content" }
const _hoisted_7 = ["onMouseover"]
const _hoisted_8 = { class: "member__name" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "team__description" }
const _hoisted_17 = { class: "member__name" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = ["src"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", {
        innerHTML: _ctx.t('Home.team.title')
      }, null, 8, _hoisted_3),
      _createElementVNode("span", {
        innerHTML: _ctx.t('Home.team.interactive')
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (index) => {
          return _createElementVNode("div", {
            class: _normalizeClass(["team__member", { active: _ctx.currentMember == index - 1 }]),
            key: index,
            onMouseover: ($event: any) => (_ctx.currentMember = index - 1)
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.t(`Home.team.members[${index - 1}].name`).split(" ")[0]) + " ", 1),
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.t(`Home.team.members[${index - 1}].name`).split(" ")[1]) + " ", 1),
              _createElementVNode("img", {
                class: "member__emoji",
                src: 
                require(`@/assets/team/emoji/${_ctx.t(
                  `Home.team.members[${index - 1}].emoji`
                )}.png`)
              
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", {
              class: "member__avatar",
              style: _normalizeStyle({
              '--background':
                '#' + _ctx.t(`Home.team.members[${index - 1}].preferredColor`),
            })
            }, [
              _createElementVNode("img", {
                src: 
                require(`@/assets/team/avatars/${_ctx.t(
                  `Home.team.members[${index - 1}].avatar`
                )}`)
              ,
                alt: _ctx.t(`Home.team.members[${index - 1}].name`)
              }, null, 8, _hoisted_11)
            ], 4),
            _createElementVNode("div", {
              class: "member__post",
              innerHTML: _ctx.t(`Home.team.members[${index - 1}].post`)
            }, null, 8, _hoisted_12),
            _createElementVNode("div", {
              class: "member__description",
              innerHTML: _ctx.t(`Home.team.members[${index - 1}].description`)
            }, null, 8, _hoisted_13),
            _createElementVNode("div", {
              class: "member__employment-exp",
              innerHTML: _ctx.t(`Home.team.members[${index - 1}].employmentExp`)
            }, null, 8, _hoisted_14),
            _createElementVNode("a", {
              class: "member__link",
              target: "_blank",
              href: "mailto:info@inkast.me",
              innerHTML: _ctx.t(`Home.team.members[${_ctx.currentMember}].link`)
            }, null, 8, _hoisted_15)
          ], 42, _hoisted_7)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, [
          _createTextVNode(_toDisplayString(_ctx.t(`Home.team.members[${_ctx.currentMember}].name`).split(" ")[0]) + " ", 1),
          _hoisted_18,
          _createTextVNode(" " + _toDisplayString(_ctx.t(`Home.team.members[${_ctx.currentMember}].name`).split(" ")[1]) + " ", 1),
          _createElementVNode("img", {
            class: "member__emoji",
            src: 
              require(`@/assets/team/emoji/${_ctx.t(
                `Home.team.members[${_ctx.currentMember}].emoji`
              )}.png`)
            
          }, null, 8, _hoisted_19)
        ]),
        _createElementVNode("span", {
          class: "member__post",
          innerHTML: _ctx.t(`Home.team.members[${_ctx.currentMember}].post`)
        }, null, 8, _hoisted_20),
        _createElementVNode("span", {
          class: "member__description",
          innerHTML: _ctx.t(`Home.team.members[${_ctx.currentMember}].description`)
        }, null, 8, _hoisted_21),
        _createElementVNode("span", {
          class: "member__employment-exp",
          innerHTML: _ctx.t(`Home.team.members[${_ctx.currentMember}].employmentExp`)
        }, null, 8, _hoisted_22),
        _createElementVNode("a", {
          class: "member__link",
          target: "_blank",
          href: "mailto:info@inkast.me",
          innerHTML: _ctx.t(`Home.team.members[${_ctx.currentMember}].link`)
        }, null, 8, _hoisted_23)
      ])
    ])
  ]))
}